"use client";

export { default } from "@stadium/shared/src/components/redeem-gift-code/apply-gift-code";
